const snookerData = [
  {
    id: 1,
    alt: "gallery image",
    img: "/assets/images/section/Othergames/ot1.jpg",
  },
  {
    id: 2,
    alt: "gallery image",
    img: "/assets/images/section/Othergames/ot2.jpg",
  },
  {
    id: 3,
    alt: "gallery image",
    img: "/assets/images/section/Othergames/ot3.jpg",
  },
  {
    id: 4,
    alt: "gallery image",
    img: "/assets/images/section/Othergames/ot4.jpg",
  },
  {
    id: 5,
    alt: "gallery image",
    img: "/assets/images/section/Othergames/ot5.jpg",
  },
  {
    id: 6,
    alt: "gallery image",
    img: "/assets/images/section/Othergames/ot6.jpg",
  },
];

export default snookerData;
